import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  maxWidth,
  MaxWidthProps,
} from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;

  ${flexDirection}
  ${gap}
`

export const ImageHolder = styled.div.withConfig({
  shouldForwardProp,
})<MaxWidthProps>`
  display: flex;
  width: 100%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 24px;
  }

  ${maxWidth}
`
